import React, { useState, useEffect ,useRef } from "react";
import apiClient from "../apiClient";
import { useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FaSpinner } from 'react-icons/fa';

import { useShop } from '../context/ShopContext';
import Sidebar from "./Sidebar";



const Boxentryenglish = () => {
    const location = useLocation();
    const navigate = useNavigate(); // For navigation
    const [products, setProducts] = useState([]);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [date, setDate] = useState(new Date().toISOString().split("T")[0]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [shopId, setShopId] = useState(null);
    const [tokenString, setToken] = useState(null);
    const [shopName,setshopName] = useState(null);
    const inputRefs = useRef([]);
    const [apiConditionMet, setApiConditionMet] = useState(null); 
    const [shopOptions, setShopOptions] = useState([]);
    const [isLoading, setIsLoading] = useState(true);  
    const [rsbclData, setRsbclData] = useState(null); 
    const [transactionNo, setTransactionNo] = useState("");
    const [boxInputs, setBoxInputs] = useState({});
    const [totalQuantities, setTotalQuantities] = useState({});
    const [receivedStockQty, setReceivedStockQty] = useState(0);
    const { userId ,companyId } = useShop(); 
    const [receiveType, setReceiveType] = useState("");
    const [selectedTypeName, setSelectedTypeName] = useState("");
    const [invoiceNo, setInvoiceNo] = useState("");
    const [shop, setShop] = useState("");
    const [partyMaster, setPartyMaster] = useState("");
    const [receiveTypes, setReceiveTypes] = useState([]);
    const [shops, setShops] = useState([]);
    const [partyMasters, setPartyMasters] = useState([]);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [remark, setRemark] = useState(""); 


const [showPreview, setShowPreview] = useState(false);
const [previewData, setPreviewData] = useState({});
const [modalIsOpen, setModalIsOpen] = useState(false);

const showToast = (message, type = "error") => {
  toast.dismiss(); 

  console.log("Toast Type:", type); 

  if (type.toLowerCase() === "error") {
    toast.error(message);
  } else if (type.toLowerCase() === "success") {
    toast.success(message);
  } else {
    console.warn("Invalid toast type:", type);
  }
};

   useEffect(() => {
     const savedShopId = localStorage.getItem("shopId");
     const savedTokenString = localStorage.getItem("tokenString");
     const savedshopName =localStorage.getItem("shopName");
 
 
 
     if (savedShopId && savedTokenString && savedshopName) {
       setShopId(savedShopId);
       setToken(savedTokenString);
       setshopName(savedshopName);
     } else {
       showToast("Please log in first!","error");
       navigate("/signin"); // Redirect to login page if not logged in
     }
   }, [navigate]);

  useEffect(() => {
    if (shopId && tokenString && shopName && shopName) {
      fetchStock();
    }
  }, [shopId, tokenString, shopName,date]); 

 
   useEffect(() => {
    const today = new Date();
    const isoDate = today.toISOString().split("T")[0]; // Get today's date in yyyy-MM-dd format
    setDate(isoDate); // Set the default date
  }, []);


   useEffect(() => {
      const today = new Date();
      const formattedDate = today
        .toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        })
        .replace(",", ""); // Remove comma if any
  
      // Convert to ISO 8601 format for <input type="date">
      const isoDate = today.toISOString().split("T")[0]; // yyyy-MM-dd
      setDate(isoDate);
    }, []);
  
  
  
  




 
  useEffect(() => {
    if (searchQuery.trim()) {
      const filtered = products.filter((product) =>
        product.name.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredProducts(filtered);
    } else {
      setFilteredProducts(products);
    }
  }, [searchQuery, products]);

  useEffect(() => {
    const today = new Date();
    const formattedDate = today
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
      .replace(",", ""); // Remove comma if any

    // Convert to ISO 8601 format for <input type="date">
    const isoDate = today.toISOString().split("T")[0]; // yyyy-MM-dd
    setDate(isoDate);
  }, []);






  const fetchStock = async () => {
    setLoading(true);
    setError(null);
    try {
        const response = await apiClient.post(
            "/Liquor/GetProductDataWithDate",
            { shopId,
              typeId: "1" ,
              stockDate:date || new Date().toISOString().split("T")[0],}
        );

        console.log("Editproductdata box: ", response);
        const fetchedProducts = response.data.data || [];

        const updatedProducts = fetchedProducts.map((product) => {
            const vt = (product.variantType || "").replace(/[^a-zA-Z0-9\s]/g, "").trim() || (/\bpet\b/i.test(product.packing || "") ? "pet" : "Bottle");
            return {
                id: product.id,
                name: product.pName,
                selected: false,
                variantType: vt,
                variants: [
                    {
                        volume: product.packing,
                        variantType: vt,
                        rate: parseFloat(product.mrp),
                        openingStock: parseFloat(product.openingStock || 0),
                        receivedStock: "",
                        transferStock: "",
                        currentStock: "",
                        isSubmitted: false,
                    },
                ],
            };
        });

        setProducts(updatedProducts);
        setFilteredProducts(updatedProducts);
        setApiConditionMet(true); 
    } catch (err) {
        setError("Error fetching stock data");
        console.error("Error fetching stock:", err);
        setApiConditionMet(false); 
    } finally {
        setLoading(false);
    }
};

  






useEffect(() => {
    const fetchReceiveTypes = async () => {
      try {
        const response = await apiClient.post(
          '/Liquor/GetRecTypeMst',
          { shopId, companyId }
        );
        console.log("fetchReceiveTypes", response);
  
        // Map the response to dropdown options
        const options = response.data?.data?.map((item) => ({
          id: item.id,
          label: item.name,
          type: item.typeName,  // Used for condition checking
          type1:item.type,


        }));
        
        console.log("recievetypeoptions:", options);
        setReceiveTypes(options);
      } catch (err) {
        console.error('Error fetching dropdown options:', err);
        showToast('Failed to load dropdown options.',"error");
      }
    };
  
    fetchReceiveTypes();
  }, []);



  useEffect(() => {
    const fetchPartyMasters = async () => {
      try {
        const response = await apiClient.post(
          '/Liquor/GetPartyMaster',
          { companyId }
        );

        
        console.log("fetchPartyMasters", response);
  
        const options = response.data?.data?.map((item) => ({
          id: item.id,
          label: item.name,
        }));
        setPartyMasters(options);
      } catch (err) {
        console.error('Error fetching party master options:', err);
        showToast('Failed to load party masters.',"error");
      }
    };
  
    fetchPartyMasters();
  }, []);
  

  useEffect(() => {
    // Function to fetch shop options from the API
    const fetchShopOptions = async () => {
      try {
        const response = await apiClient.post(
          '/Liquor/GetShopMaster',
          { userId ,companyId }
        );


        console.log("fetchShopOptions67:", response)
  
        const options = response.data?.data?.map((item) => ({
          id: item.id,
          label: item.name,
        }));
        console.log("options",options)
        
        // Assuming the API returns an array of shop options
        setShopOptions(options);
        setIsLoading(false); // Set loading to false after data is fetched
      } catch (err) {
        showToast('Failed to fetch shop options');
        setIsLoading(false);
      }
    };
  
    fetchShopOptions(); // Call the function to fetch data
  }, []); 


 


  const handleCheckboxChange = (productId) => {
    setSelectedProducts((prevSelected) => {
      if (prevSelected.includes(productId)) {
        return prevSelected.filter(id => id !== productId);
      } else {
        return [...prevSelected, productId];
      }
    });
  };

  const handleMobileReceiveChange = (productId, value) => {
    const idx = filteredProducts.findIndex(p => p.id === productId);
    if (idx < 0) return;
    const previousValue = Number(filteredProducts[idx].variants[0].receivedStock) || 0;
    const numericValue = value === "" ? 0 : Math.max(0, Number(value));
    const updatedProducts = [...filteredProducts];
    updatedProducts[idx] = { ...updatedProducts[idx], variants: [{ ...updatedProducts[idx].variants[0], receivedStock: value === "" ? "" : numericValue }] };
    setFilteredProducts(updatedProducts);
    setSelectedProducts(prev => value !== "" && numericValue > 0
      ? prev.includes(productId) ? prev : [...prev, productId]
      : prev.filter(id => id !== productId));
    setTotalQuantities(prev => ({ ...prev, [productId]: (Number(prev[productId]) || 0) - previousValue + numericValue }));
    setReceivedStockQty(prev => ({ ...prev, [productId]: value === "" ? "" : numericValue }));
  };




  const handleReceivedStockChange = (productIndex, variantIndex, value) => {
    let updatedProducts = [...filteredProducts];
    let isPreviewMode = showPreview;  // agar preview open hai
    let productsArray = isPreviewMode ? [...previewData.selectedProducts] : [...filteredProducts];
  
    const productId = productsArray[productIndex].id;
    const previousValue = Number(productsArray[productIndex].variants[variantIndex].receivedStock) || 0;
    const numericValue = value === "" ? "" : Number(value);
  
    if (!selectedProducts.includes(productId)) return;
  
    // Input blank case
    if (value === "") {
      productsArray[productIndex].variants[variantIndex].receivedStock = "";
  
      if (isPreviewMode) {
        setPreviewData((prev) => ({
          ...prev,
          selectedProducts: productsArray,
        }));
      } else {
        setFilteredProducts(productsArray);
      }
  
      setTotalQuantities((prev) => ({
        ...prev,
        [productId]: (Number(prev[productId]) || 0) - previousValue,
      }));
  
      setReceivedStockQty((prev) => ({
        ...prev,
        [productId]: "",
      }));
  
      return;
    }
  
    // Negative value case
    if (numericValue < 0) {
      showToast("Negative values are not allowed!", "error");
  
      productsArray[productIndex].variants[variantIndex].receivedStock = "";
  
      if (isPreviewMode) {
        setPreviewData((prev) => ({
          ...prev,
          selectedProducts: productsArray,
        }));
      } else {
        setFilteredProducts(productsArray);
      }
  
      setTotalQuantities((prev) => ({
        ...prev,
        [productId]: (Number(prev[productId]) || 0) - previousValue,
      }));
  
      setReceivedStockQty((prev) => ({
        ...prev,
        [productId]: "",
      }));
  
      return;
    }
  
    // Normal positive input
    productsArray[productIndex].variants[variantIndex].receivedStock = numericValue;
  
    if (isPreviewMode) {
      setPreviewData((prev) => ({
        ...prev,
        selectedProducts: productsArray,
      }));
    } else {
      setFilteredProducts(productsArray);
    }
  
    setTotalQuantities((prev) => ({
      ...prev,
      [productId]: (Number(prev[productId]) || 0) - previousValue + numericValue,
    }));
  
    setReceivedStockQty((prev) => ({
      ...prev,
      [productId]: numericValue,
    }));
  };
  
  
  
  
  
  


  const handleReceiveTypeChange = async (e) => {
    const selectedId = e.target.value;
    setReceiveType(selectedId);

    const selectedOption = receiveTypes.find(
        (option) => option.id.toString() === selectedId
    );

    console.log("Selected Option:", selectedOption); 
    console.log("Selected Type:", selectedOption?.type); 
    setSelectedTypeName(selectedOption ? selectedOption.type : "");

    // Reset dependent fields
    setInvoiceNo("");
    setShop("");
    setPartyMaster("");
    setTransactionNo(""); 

    let apiType = selectedOption?.type1;

    console.log("Final API Type:", apiType); 

    try {
        const response = await apiClient.post(
            "/Liquor/GetTransactionNo",
            { type: apiType, companyId: companyId ,typeId: "1" }
        );

        console.log("API Response:", response.data);

        if (response.data?.code === 200 && response.data?.data) {
            setTransactionNo(response.data.data); 
            showToast(`Transaction No. received!`, "success");
        } else {
            showToast("Invalid response from API!", "error");
        }
    } catch (err) {
        console.error("API Error:", err);
        showToast("Failed to fetch transaction number!", "error");
    }
};





  
  

const handleSubmit = async (event) => {
  event.preventDefault();

  try {
    // Step 1: General Validations
    if (!receiveType) {
      showToast("Please select a Receive Type.", "error");
      return;
    }

    if (selectedTypeName === "RSBCL" && (!invoiceNo || !remark)) {
      showToast("Invoice No. and Remark are required for RSBCL.", "error");
      return;
    }

    if (selectedTypeName === "SHOP" && !shop) {
      showToast("Please select a Shop.", "error");
      return;
    }

    if (
      selectedTypeName !== "RSBCL" &&
      selectedTypeName !== "SHOP" &&
      !partyMaster
    ) {
      showToast("Please select a Party Master.", "error");
      return;
    }

    // Step 2: Ensure at least one product is selected
    if (selectedProducts.length === 0) {
      showToast("Please select at least one product!", "error");
      return;
    }

    // Step 3: Ensure each selected product has received stock
    for (const product of filteredProducts) {
      if (selectedProducts.includes(product.id)) {
        const receivedQty = Number(totalQuantities?.[product.id] || 0);
        if (receivedQty <= 0) {
          showToast(`Please enter received stock for ${product.name}!`, "error");
          return;
        }
      }
    }

    // Step 4: Prepare selected product data from user input
    const selectedData = filteredProducts
      .filter((product) => selectedProducts.includes(product.id))
      .map((product) => ({
        ProductId: product.id,
        ReceivedQty: Number(receivedStockQty[product.id] || 0), 
        ReceivedHeadQty: Number(totalQuantities?.[product.id] || 0),
        boxQty: Number(boxInputs?.[product.id] || 0) // Add boxQty from input
      }));

    // Final values
    const finalInvoiceNo = invoiceNo?.trim() || "0";
    const finalPartyMaster = partyMaster || "0";
    const finalShop = shop || "0";

    const payload = {
      ReceivedHeadId: receiveType,
      ReceivedPartyId: finalPartyMaster,
      ReceivedShopId: finalShop,
      ShopId: shopId,
      StockDate: date || new Date().toISOString().split("T")[0],
      InvoiceNo: finalInvoiceNo,
      Remark: remark,
      TransactionNo: "0",
      TransactionNumber: transactionNo,
      receivedQtyDetails: selectedData,
    };

    console.log("Data being sent to API:", JSON.stringify(payload, null, 2));

    setLoading(true);

    // Step 5: Submit data to API
    const response = await apiClient.post(
      "/Liquor/SaveBulkProductReceivedDetails",
      payload
    );

    console.log("API Response received:", response.data);
    if (response.status === 200) {
      if (response.data && response.data.code !== 200) {
        showToast(response.data.data || "Negative stock not allowed!", "error");
      } else {
        showToast("Stock report submitted successfully!", "success");
        fetchStock();
      }
    } else {
      showToast(`Error submitting stock report: ${response.statusText}`, "error");
    }
  } catch (error) {
    console.error("Error submitting data:", error);
    showToast(error.response?.data?.message || "Failed to submit data!", "error");
  } finally {
    setLoading(false);
  }
};


const handlePreview = () => {
  if (filteredProducts.length === 0) {
    showToast("No product data available for preview!", "error");
    return;
  }

  const editedProducts = filteredProducts
    .filter((product) => selectedProducts.includes(product.id)) // only selected products
    .map((product) => {
      const boxQuantity = Number(totalQuantities[product.id]) || 0; // fetched total calculated
      const receivedStock = Number(receivedStockQty[product.id]) || 0; // separately fetched received stock

      // Mapping variants to include updated 'receivedStock' value
      const updatedVariants = product.variants.map((variant) => ({
        ...variant,
        receivedStock: variant.receivedStock || "", // Updated receivedStock
        totalQuantity: getTotalQuantity(product.id),
      }));

      return {
        ...product,
        boxCount: boxInputs[product.id] || "", // box input
        variants: updatedVariants,
      };
    })
    .filter((product) => parseFloat(product.boxCount) > 0); // only show if box filled

  if (editedProducts.length === 0) {
    showToast("Please enter box count to preview!", "error");
  } else {
    setPreviewData({ selectedProducts: editedProducts });
    setShowPreview(true);
  }
};



const getTotalQuantity = (productId) => {
  return (Number(totalQuantities[productId]) || 0);
};

  const calculateTotalQuantity = (productId, variant) => {
    const boxCount = parseFloat(boxInputs[productId]) || 0;
    return boxCount * (variant.unitPerBox || 1); // Or any logic you use
  };
  

  const handleBoxChange = async (productId, value) => {
    // Update the boxInputs state
    setBoxInputs(prev => ({ ...prev, [productId]: value }));
  
    // Only proceed if value is a valid number
    const parsedValue = parseInt(value, 10);
  
    if (!isNaN(parsedValue) && parsedValue >= 0) {
      try {
        const response = await apiClient.post(
          '/Liquor/GetProductQty',
          {
            productId: productId,
            boxCount: parsedValue
          }
        );
  
        console.log("Boxwise quantity response:", response);
  
        const quantity = response.data?.data?.quantity || 0;
  
        // Update totalQuantities with the received quantity
        setTotalQuantities(prev => ({
          ...prev,
          [productId]: quantity + (Number(receivedStockQty[productId]) || 0)
        }));
  
      } catch (error) {
        console.error("Error fetching boxwise quantity:", error);
        showToast("Failed to fetch quantity for the entered box count.", "error");
      }
    } else if (value === "") {
      // Handle blank input - reset quantity
      setTotalQuantities(prev => ({
        ...prev,
        [productId]: 0
      }));
    } else {
      showToast("Please enter a valid box quantity.", "error");
    }
  };
  



const handleTotalQuantityChange = (productId, value) => {
  setTotalQuantities((prev) => ({
    ...prev,
    [productId]: value,
  }));
};
  
  
  
  
  
  
    
    
    
  const _mlSz = s => { const m = (s||"").match(/\d+(?:\.\d+)?/); return m ? parseFloat(m[0]) : 0; };
  const buildBoxGroups = prods => {
    const order = []; const map = new Map();
    prods.forEach(p => { if (!map.has(p.name)) { map.set(p.name, []); order.push(p.name); } map.get(p.name).push(p); });
    return order.map(name => ({ name, prods: map.get(name).sort((a,b) => _mlSz(b.variants[0]?.volume) - _mlSz(a.variants[0]?.volume)) }));
  };

  return (
    <>
    <style>{`
      .bx-mobile{padding:12px;background:#F3F4F6;min-height:60vh;}
      .bx-card{background:#fff;border-radius:12px;margin-bottom:12px;box-shadow:0 1px 4px rgba(0,0,0,.08);overflow:hidden;}
      .bx-card-hdr{display:flex;align-items:center;justify-content:space-between;padding:11px 14px;border-bottom:1px solid #F3F4F6;}
      .bx-card-name{font-weight:700;font-size:14px;color:#111;display:flex;align-items:center;gap:8px;}
      .bx-dot{width:8px;height:8px;border-radius:50%;background:#D1D5DB;flex-shrink:0;}
      .bx-dot.on{background:#10B981;}
      .bx-vcount{font-size:11px;color:#6B7280;background:#F3F4F6;border-radius:20px;padding:2px 8px;font-weight:600;}
      .bx-th-row{display:grid;grid-template-columns:1fr 60px 52px 72px;padding:5px 14px;background:#F9FAFB;border-bottom:1px solid #F0F0F0;}
      .bx-th{font-size:10px;font-weight:600;color:#9CA3AF;text-transform:uppercase;letter-spacing:.05em;}
      .bx-th:not(:first-child){text-align:center;}
      .bx-th:last-child{text-align:right;}
      .bx-sect{font-size:11px;font-weight:700;letter-spacing:.08em;padding:6px 14px 4px;display:flex;align-items:center;gap:8px;color:#7C2D12;}
      .bx-sect.pet{color:#D97706;}
      .bx-sect::after{content:'';flex:1;height:1px;background:currentColor;opacity:.22;}
      .bx-row{display:grid;grid-template-columns:1fr 60px 52px 72px;padding:8px 14px;border-bottom:1px solid #F9FAFB;align-items:center;}
      .bx-col-var{font-size:13px;font-weight:600;color:#111;}
      .bx-col{font-size:13px;color:#374151;text-align:center;}
      .bx-col-recv{text-align:right;}
      .bx-inp{width:68px;border:1.5px solid #D1D5DB;border-radius:8px;padding:5px 7px;font-size:13px;text-align:right;outline:none;background:#F9FAFB;color:#111;}
      .bx-inp:focus{border-color:#6D214F;background:#fff;}
      .bx-inp.on{border-color:#10B981;background:#ECFDF5;}
      .bx-footer{display:flex;justify-content:space-between;align-items:center;padding:9px 14px;background:#F9FAFB;border-top:1px solid #EFEFEF;font-size:12px;color:#6B7280;}
      .bx-footer strong{color:#111;}
    `}</style>
    <div className="app-main flex-column flex-row-fluid" id="kt_app_main">
    {/* Content wrapper */}
    <div className="d-flex flex-column flex-column-fluid">
        {/* Toolbar */}
        <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
            {/* Toolbar container */}
            <div id="kt_app_toolbar_container" className="app-container container-fluid d-flex flex-stack">
                {/* Page title */}
                <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                    {/* Title */}
                    <h1 className="page-heading d-flex text-gray-900 fw-bold fs-3 flex-column justify-content-center my-0">
                    Box Add Receive Stock
                    </h1>
                    <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                        <li className="breadcrumb-item text-muted">
                            <a href="index.html" className="text-muted text-hover-primary">Home</a>
                        </li>
                        <li className="breadcrumb-item">
                            <span className="bullet bg-gray-500 w-5px h-2px"></span>
                        </li>
                        <li className="breadcrumb-item text-muted">Dashboards</li>
                    </ul>
                </div>
            </div>
        </div>
  
        <div id="kt_app_content" className="app-content flex-column-fluid">
            <div id="kt_app_content_container" className="app-container container-fluid">
                <div className="row g-5 g-xl-10 mb-5 mb-xl-10">
                    <div className="col-xl-12">
                        <div className="card card-flush h-md-100">
                            <ToastContainer />
                          
                            <div className="card-body pt-6">
                                <div className="table-responsive">
                                    <div className="panel-body">
                                        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                            <form className="form-inline">
                                                <div className="form-group">
                                                    <p className="form-control-static">Search Products:</p>
                                                </div>
                                                <div className="form-group d-flex justify-content-between gap-5">
                                                      <label htmlFor="inputsearch" className="sr-only active">Search Products</label>
                                                      <input className="form-control" id="inputsearch" placeholder="Search Products"      value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)} type="text" autoComplete="off" />
                                                     
                                                      <input
    className="form-control  "
    id="inputsearch"
    placeholder="Search Products"
    type="date"
    value={date} // Always in correct format
    max={new Date().toISOString().split("T")[0]} // Restrict future dates
    onChange={(e) => setDate(e.target.value)} // Update state
    autoComplete="off"
  />
                                                  </div>

                                            </form>



                                            <div className="form-group">
<label htmlFor="receiveType">Receive Type</label>
<select
  className="form-control"
  id="receiveType"
  value={receiveType}
  onChange={handleReceiveTypeChange}
>
  <option value="">Select Receive Type</option>
  {receiveTypes.map((option) => (
    <option key={option.id} value={option.id}>
      {option.label}
    </option>
  ))}
</select>
</div>

              {/* Conditional Fields */}
              
              {selectedTypeName === "RSBCL" && (
<>
  <div className="form-group">
    <label htmlFor="invoiceNo">Invoice No.</label>
    <input
      type="text"
      className="form-control"
      id="invoiceNo"
      placeholder="Enter Invoice No."
      value={invoiceNo}
      onChange={(e) => setInvoiceNo(e.target.value)}
    />
  </div>

  <div className="form-group">
    <label htmlFor="remark">Remark</label>
    <input
      type="text"
      className="form-control"
      id="remark"
      placeholder="Enter Remark"
      value={remark}
      onChange={(e) => setRemark(e.target.value)}
    />
  </div>
</>
)}

{/* Shop Dropdown (Only for SHOP) */}
{selectedTypeName === "SHOP" && (
<div className="form-group">
  <label htmlFor="shopDropdown">Shop</label>
  <select
    className="form-control"
    id="shopDropdown"
    value={shop}
    onChange={(e) => setShop(e.target.value)}
  >
    <option value="">Select Shop</option>
    {shopOptions.map((option) => (
      <option key={option.id} value={option.id}>{option.label}</option>
    ))}
  </select>
</div>
)}


{selectedTypeName !== "RSBCL" && selectedTypeName !== "SHOP" && (
<div className="form-group">
  <label htmlFor="partyMaster">Party Master</label>
  <select
    className="form-control"
    id="partyMaster"
    value={partyMaster}
    onChange={(e) => setPartyMaster(e.target.value)}
  >
    <option value="">Select Party Master</option>
    {partyMasters.map((party) => (
      <option key={party.id} value={party.id}>
        {party.label}
      </option>
    ))}
  </select>
</div>
)}
   


<div className="panel-heading">


  {transactionNo && (
    <span
      style={{
        position: "absolute",
        right: "45px",
        top: "60px", 
        fontWeight: "bold",
        color: "green",
        fontSize: "20px",
      }}
    >
      Transaction No: {transactionNo}
    </span>
  )}
</div>




















                                        </div>
                                        <div className="clearfix"></div>
                                        <br />
                                        {apiConditionMet === null ? (
    <div className="loader-container">
             <FaSpinner className="spinner-icon" />
           </div>
  ) : apiConditionMet ? (
    <>
    {/* ── Desktop table ── */}
    <div className="table-responsive h-400px d-none d-md-block">
      <table className="table table-bordered table-striped">
        <thead>
          <tr>
            <th>Select</th><th>Product Name</th><th>Volume</th><th>Rate</th>
            <th>Opening Stock</th><th>Received Stock</th><th>Box</th><th>Total Quantity</th>
          </tr>
        </thead>
        <tbody>
          {filteredProducts.length > 0 ? filteredProducts.map((product, index) =>
            product.variants.map((variant, vIndex) => (
              <tr key={`${index}-${vIndex}`}>
                <td><label className="checkbox-container"><input type="checkbox" checked={selectedProducts.includes(product.id)} onChange={() => handleCheckboxChange(product.id)} /></label></td>
                <td>{product.name}</td>
                <td>{variant.volume}</td>
                <td className="numeric-input">{variant.rate}</td>
                <td className="numeric-input">{variant.openingStock}</td>
                <td className="numeric-input"><input type="text" value={variant.receivedStock} onChange={(e) => handleReceivedStockChange(index, vIndex, e.target.value)} className="form-control" min="0" /></td>
                <td className="numeric-input"><input type="text" min="0" value={boxInputs[product.id] || ""} onChange={(e) => handleBoxChange(product.id, e.target.value)} className="form-control" disabled={!selectedProducts.includes(product.id)} /></td>
                <td className="numeric-input">{totalQuantities[product.id] || 0}</td>
              </tr>
            ))
          ) : <tr><td colSpan={8}></td></tr>}
        </tbody>
      </table>
      <button type="button" data-bs-toggle="modal" data-bs-target="#model3" className="btn btn-info mt-3 m-2" onClick={handlePreview}>Preview</button>
      <button type="button" className="btn btn-info mt-3 m-2" onClick={handleSubmit} disabled={loading}>{loading ? "Submitting..." : "Submit Report"}</button>
    </div>

    {/* ── Mobile cards ── */}
    <div className="bx-mobile d-md-none">
      {buildBoxGroups(filteredProducts).map(({name, prods: grpProds}) => {
        const bottleProds = grpProds.filter(p => p.variantType?.toLowerCase() !== "pet");
        const petProds    = grpProds.filter(p => p.variantType?.toLowerCase() === "pet");
        const totalQty    = grpProds.reduce((s, p) => s + (Number(totalQuantities[p.id]) || 0), 0);
        const filledCount = grpProds.filter(p => selectedProducts.includes(p.id)).length;
        const renderBxRows = plist => plist.map(p => {
          const v = p.variants[0];
          const recv = v.receivedStock;
          const done = recv !== "" && Number(recv) > 0;
          return (
            <div key={p.id} className="bx-row">
              <span className="bx-col-var">{v.volume}</span>
              <span className="bx-col">₹{Number(v.rate).toLocaleString('en-IN')}</span>
              <span className="bx-col">{v.openingStock}</span>
              <span className="bx-col-recv">
                <input type="number" min="0" value={recv} placeholder="0"
                  onChange={e => handleMobileReceiveChange(p.id, e.target.value)}
                  className={`bx-inp${done?" on":""}`}/>
              </span>
            </div>
          );
        });
        return (
          <div key={name} className="bx-card">
            <div className="bx-card-hdr">
              <span className="bx-card-name">
                <span className={`bx-dot${filledCount>0?" on":""}`}/>
                {name}
              </span>
              <span className="bx-vcount">{grpProds.length}v</span>
            </div>
            <div className="bx-th-row">
              <span className="bx-th">VARIANT</span>
              <span className="bx-th" style={{textAlign:"center"}}>RATE</span>
              <span className="bx-th" style={{textAlign:"center"}}>STOCK</span>
              <span className="bx-th" style={{textAlign:"right"}}>RECEIVE</span>
            </div>
            {bottleProds.length>0 && <><div className="bx-sect bottle">BOTTLE</div>{renderBxRows(bottleProds)}</>}
            {petProds.length>0    && <><div className="bx-sect pet">PET</div>{renderBxRows(petProds)}</>}
            <div className="bx-footer">
              <span>Total Qty: <strong>{totalQty}</strong></span>
            </div>
          </div>
        );
      })}
      <div style={{display:"flex",gap:10,padding:"4px 0 20px"}}>
        <button type="button" className="btn btn-info flex-fill" onClick={handleSubmit} disabled={loading}>{loading?"Submitting...":"Submit"}</button>
      </div>
    </div>
    </>
                                          ) : (
                                            <p>Already Submitted Data</p>
                                          )}
                                          <div class="text-right align-items-right d-flex justify-content-end">
      <button type="submit" data-bs-toggle="modal" data-bs-target="#model3" className="btn btn-info mt-3 m-2"  onClick={handlePreview}>Preview</button>
       <button type="submit" className="btn btn-info mt-3 m-2"    onClick={handleSubmit}disabled={loading}   >{loading ? "Submitting..." : "Submit Report"}</button>
       </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  
    {/* Footer */}
    <div id="kt_app_footer" className="app-footer">
        <div className="app-container container-fluid d-flex flex-column flex-md-row flex-center flex-md-stack py-3">
            <div className="text-gray-900 order-2 order-md-1">
                <span className="text-muted fw-semibold me-1">2025&copy;</span>
                <a href="#" target="_blank" className="text-gray-800 text-hover-primary">WineShop</a>
            </div>
        </div>
    </div>

  
  
  
  
  
  
  
  {/* For transfer modal */}
  
  

  
  
  
  
  
      {/* Preview modal */}
  
      <div
  className="modal fade"
  id="model3"
  tabIndex={-1}
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
  >
  <div className="modal-dialog modal-lg">
  <div className="modal-content">
  <div className="modal-header">
  <h1 className="modal-title fs-5" id="exampleModalLabel">
  Preview Details
  </h1>
  <p><strong>Invoice No.:</strong> {invoiceNo}</p>
  <p><strong>Remark:</strong> {remark}</p>
  <button
  type="button"
  className="btn-close"
  data-bs-dismiss="modal"
  aria-label="Close"
  />
  </div>
  
  <div className="modal-body">
  <div className="previewdata">
          <table className="table table-bordered table-striped" >
          <thead>
          <tr>
              <th>Product Name</th>
              <th>Volume</th>
              <th>Rate</th>
              <th>Received Stock</th> {/* 👈 Editable */}
              <th>Box</th> {/* 👈 Editable */}
              <th>Total Quantity</th> {/* 👈 Auto Calculated */}
            </tr>
        </thead>
        <tbody>
            {previewData?.selectedProducts?.map((product, index) =>
              product.variants.map((variant, vIndex) => (
                <tr key={`${index}-${vIndex}`}>
                  <td>{product.name}</td>
                  <td>{variant.volume}</td>
                  <td>{variant.rate}</td>

                  {/* ✅ Editable Received Stock */}
                  <td className="numeric-input">
                    <input
                      type="text"
                      value={variant.receivedStock || ""}
                      onChange={(e) =>
                        handleReceivedStockChange(index, vIndex, e.target.value)
                      }
                      className="form-control"
                      min="0"
                      disabled={!selectedProducts.includes(product.id)}
                    />
                  </td>

                  {/* ✅ Editable Box Input */}
                  <td className="numeric-input">
                    <input
                      type="text"
                      min="0"
                      value={boxInputs[product.id] || ""}
                      onChange={(e) => handleBoxChange(product.id, e.target.value)}
                      className="form-control"
                      disabled={!selectedProducts.includes(product.id)}
                    />
                  </td>

                  {/* ✅ Show total quantity */}
                  <td>{totalQuantities[product.id] || "-"}</td>
                </tr>
              ))
            )}
          </tbody>
          </table>
        </div>
  </div>
  
  <div className="modal-footer">
  <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
  Close
  </button>
  </div>
  </div>
  </div>
  </div>
  
  </div>
  </>
  );
};

export default Boxentryenglish;